export const AddonScalesService = {
  getAll({
    page = 1,
    limit = 25,
    search = "",
    module = "",
    organization_id = ""
  }) {
    return axios.get(`admin/addon-scales`, {
      params: {
        page,
        limit,
        search,
        module,
        organization_id
      }
    });
  },
  getByOrganizations({ module = "" }) {
    return axios.get(`admin/addon-scales/organizations`, {
      params: {
        module
      }
    });
  },
  getGeneral({ module = "" }) {
    return axios.get(`admin/addon-scales/general`, {
      params: {
        module
      }
    });
  },
  getOne(id) {
    return axios.get(`admin/addon-scales/${id}`);
  },
  store(data) {
    return axios.post(`admin/addon-scales`, data);
  },
  update(id, data) {
    return axios.put(`admin/addon-scales/${id}`, data);
  },
  updateOrder(data) {
    return axios.put(`admin/addon-scales/order`, data);
  },
  delete(id) {
    return axios.delete(`admin/addon-scales/${id}`);
  }
};
